import { TimeFilter } from './types';

const dayTimeFilters: TimeFilter[] = [
    TimeFilter.Sunday,
    TimeFilter.Monday,
    TimeFilter.Tuesday,
    TimeFilter.Wednesday,
    TimeFilter.Thursday,
    TimeFilter.Friday,
    TimeFilter.Saturday,
];

export default dayTimeFilters;
